import User from '@/models/user';
import { UserProps } from '@/interfaces/models/user';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat(({ user, ...orderProps}: any) => {
      return {
        user: new User(user),
        ...orderProps,
      }
    });
  }
};
